import Main from './components/Main';
import Contact from './components/Contact';
import Experiences from './components/Experiences';
import Education from './components/Education';
import Navbar from './components/Navbar';
import Projects from './components/Projects';
import BackgroundView from './Layout/BackgroundView';

function App() {

  return (
    <BackgroundView>
      <div className='font-poppins text-black bg-white dark:bg-[#20262E] dark:text-white  transition duration-500'>
        <Navbar />
        <Main />
        <Experiences />
        <Education />
        <Projects />
        <Contact />
      </div>
    </BackgroundView>
  )
}

export default App